<template>
  <div>
    <!--工具条-->
    <el-form :inline="true" :model="filters">
      <el-form-item style="margin-bottom:10px">
        <el-button size="small" type="success" @click="handleCreate">添加</el-button>
      </el-form-item>
      <el-form-item style="margin-bottom:10px">
        <el-input size="small" v-model="filters.search" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom:10px">
        <el-button size="small" type="primary" @click="queryAll">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="mini" stripe border :data="tableData" highlight-current-row expand-on-click-node="false"
      style="width: 100%">
      <el-table-column prop="Code" label="编号" width="200"></el-table-column>
      <el-table-column prop="Name" label="名称" min-width="100"></el-table-column>
      <el-table-column prop="Description" label="备注" min-width="120"></el-table-column>
      <el-table-column prop="InsertTime" label="创建时间" width="150">
        <template slot-scope="scope">
             {{ format.dateTimeFormat(scope.row.InsertTime) }} 
            </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
        :current-page.sync="pageIndex"></el-pagination>
    </div>
    <!--新增框 -->
    <div v-if="formVisible">
      <el-dialog v-dragDialog :title="textMap[dialogStatus]" :visible.sync="formVisible" width="600px"
        :close-on-click-modal="false">
        <el-form :model="dataForm" ref="dataForm" label-width="120px" :rules="formRules">
          <el-form-item label="编号：" prop="Code">
            <el-input clearable v-model="dataForm.Code" auto-complete="off" placeholder="请输入编号"></el-input>
          </el-form-item>
          <el-form-item label="名称：" prop="Name">
            <el-input clearable v-model="dataForm.Name" auto-complete="off" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="Description">
            <el-input clearable v-model="dataForm.Description" auto-complete="off" placeholder="请输入备注说明"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button v-if="dialogStatus == 'create'" type="primary" @click="createSubmit">提交</el-button>
          <el-button v-else type="primary" @click="updateSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getPageList, save, deleteObj } from "@/api/product/productType";
export default {
  components: {
  },
  data() {
    return {
      filters: {
        search: "",
      },
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 5,
      pageSizesList: [5, 10, 15, 20, 30, 50],
      dialogStatus: "",
      formVisible: false,
      textMap: {
        create: "创建",
        update: "修改",
      },
      dataForm: {},
      formRules: {
        Code: [{ required: true, message: "请输入编号", trigger: "change" }],
        Name: [{ required: true, message: "请输入名称", trigger: "change" }],
      },
    };
  },
  methods: {
    queryAll() {
      let para = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
      };
      getPageList(para).then((response) => {
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
        }
      });
    },
    productTypeChanged(data) {
      this.filters.productType = data;
      this.queryAll();
    },
    handleCreate() {
      this.dialogStatus = "create";
      this.formVisible = true;
      this.dataForm = {};
    },

    createSubmit: function () {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.dataForm);
          save(para).then((response) => {
            if (response) {
              this.formVisible = false;
              this.queryAll();
            }
          });
          //});
        }
      });
    },

    handleUpdate(row) {
      this.dataForm = Object.assign({}, row);
      this.dialogStatus = "update";
      this.formVisible = true;
    },

    updateSubmit: function () {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        let data = Object.assign({}, this.dataForm);
        save(data).then((response) => {
          if (response) {
            this.formVisible = false;
            this.queryAll();
          }
        });
      });
    },
    //删除
    handleDelete: function (index, row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = { key: row.Key };
        deleteObj(para).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.queryAll();
          }
        });
      });
    },
    handleSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },

    handleCurrentChange(val) {
      this.pageIndex = val;
      this.queryAll();
    },
  },
  mounted() {
    this.queryAll();
  },
};
</script>
